<template>
  <div class="news">
    <div class="lunbo">
      <el-carousel trigger="hover" width="520">
        <el-carousel-item v-for="(item, index) in lunbo" :key="index">
          <router-link :to="{ name: '新闻中心详情', query: { id: item.id } }">
            <img :src="item.coverImg" :alt="item.title" class="lunbo_img" />
            <p class="lunbo_title">{{ item.title }}</p>
          </router-link>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="xinwenList">
      <div class="xwdt">
        <div class="line_ddd">
          <div class="line_blue"></div>
        </div>
        <div class="title">
          <span>新闻动态</span>
          <router-link to="/pressCenter?number=001017">
            <span>更多</span>
            <img src="../../../assets/img/more_blue.png" alt="" />
          </router-link>
        </div>
        <div class="dataList">
          <div v-for="(item, index) in xwdtList" :key="index">
            <router-link :to="{ name: '新闻中心详情', query: { id: item.id } }">
              <div>
                <img
                  src="../../../assets/img/arrow.png"
                  style="height: 16px; width: 10px; margin-right: 10px"
                />
                <span>{{ item.title }}</span>
              </div>
              <span>[{{ item.logintime }}]</span>
            </router-link>
          </div>
        </div>
      </div>
      <div v-if="cityDetail.homeShowLogin" class="homeLoginDiv">
        <div class="loginStatus" v-if="isLogin">
          <div class="userHeadImg">
            <img :src="userInfoData.cover ? userInfoData.cover : cover" />
          </div>
          <span>您好，{{ userInfoData.name }}，欢迎光临</span>
          <span>{{
            deptName +
            (cityDetail.homeTitle
              ? cityDetail.homeTitle
              : "农村集体财产监督管理平台")
          }}</span>
        </div>
        <div class="rightLogin" v-else>
          <div class="titleDiv">
            <span class="title">个人用户登录</span>
          </div>
          <div class="loginWindow">
            <div class="usernameDiv">
              <img src="@/assets/img/loginusername.png" style="" />
              <input
                type="text"
                placeholder="请输入手机号"
                v-model="username"
              />
            </div>
            <div class="passwordDiv">
              <img src="@/assets/img/loginpassword.png" class="passwordImg" />
              <input
                :type="showPassword ? 'text' : 'password'"
                placeholder="请输入登录密码"
                v-model="password"
                class="passwordInp"
              />
              <img
                v-if="showPassword"
                src="@/assets/img/closeEye.png"
                @click="showPassword = !showPassword"
                class="selectImg"
              />
              <img
                v-else
                src="@/assets/img/openEye.png"
                @click="showPassword = !showPassword"
                class="selectImg"
              />
            </div>
            <div @click="login" class="loginBtn">
              <span class="loginSpan">登 录</span>
            </div>
            <div class="loginFooter">
              <div></div>
              <div>
                <router-link to="/register" class="registerSpan"
                  >立即注册</router-link
                >
                <span
                  class=""
                  style="font-size: 16px; display: inline-block; margin: 0 10px"
                  >|</span
                ><a class="forgetPassword" @click="isShow = true">忘记密码</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="xinwenList right" v-else>
        <div class="zcfg">
          <div class="line_ddd">
            <div class="line_blue"></div>
          </div>
          <div class="title">
            <span>政策法规</span>
            <router-link to="/policiesRegulations">
              <span>更多</span>
              <img src="../../../assets/img/more_blue.png" alt="" />
            </router-link>
          </div>
          <div class="dataList">
            <div v-for="(item, index) in zcfgList" :key="index">
              <router-link
                :to="{ name: '政策法规详情', query: { id: item.id } }"
              >
                <div>
                  <img
                    src="../../../assets/img/arrow.png"
                    style="height: 16px; width: 10px; margin-right: 10px"
                  />
                  <span>{{ item.title }}</span>
                </div>
                <span>[{{ item.logintime }}]</span>
              </router-link>
            </div>
          </div>
        </div>
        <div class="zcfg" v-if="cityDetail.haveCJGG">
          <div class="line_ddd">
            <div class="line_blue"></div>
          </div>
          <div class="title">
            <span>成交公告</span>
            <router-link to="/chengjiaogonggao?number=030001">
              <span>更多</span>
              <img src="../../../assets/img/more_blue.png" alt="" />
            </router-link>
          </div>
          <div class="dataList">
            <div v-for="(item, index) in gsggList" :key="index">
              <router-link
                :to="{ name: '成交公告详情', query: { id: item.id } }"
              >
                <div>
                  <img
                    src="../../../assets/img/arrow.png"
                    style="height: 16px; width: 10px; margin-right: 10px"
                  />
                  <span>{{ item.title }}</span>
                </div>
                <span>[{{ item.logintime }}]</span>
              </router-link>
            </div>
          </div>
        </div>
        <div class="zlxz" v-else>
          <div class="line_ddd">
            <div class="line_blue"></div>
          </div>
          <div class="title">
            <span>资料下载</span>
            <router-link to="/dataDownload">
              <span>更多</span>
              <img src="../../../assets/img/more_blue.png" alt="" />
            </router-link>
          </div>
          <div class="dataList">
            <div v-for="(item, index) in zlxzList" :key="index">
              <router-link
                :to="{ name: '资料下载详情', query: { id: item.id } }"
              >
                <div>
                  <img
                    src="../../../assets/img/arrow.png"
                    style="height: 16px; width: 10px; margin-right: 10px"
                  />
                  <span>{{ item.title }}</span>
                </div>
                <span>[{{ item.logintime }}]</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      class="passwordDialog"
      :visible.sync="isShow"
      width="800px"
      center
      title="找回密码"
      style="zoom: 1.25"
    >
      <div class="steps">
        <el-steps :active="active" finish-status="success" style="width: 300px">
          <el-step title="验证信息"></el-step>
          <el-step title="完成"></el-step>
        </el-steps>
      </div>

      <div class="formView">
        <div class="formInput" v-if="active == 0">
          <p>电话号码：</p>
          <input
            placeholder="请输入电话号码"
            placeholder-class="placeholder"
            type="text"
            v-model="form.phone"
          />
        </div>

        <div class="formInput" v-if="active == 0">
          <p>新密码：</p>
          <input
            placeholder="请输入新密码"
            placeholder-class="placeholder"
            :type="showNewPassword ? 'text' : 'password'"
            v-model="form.newPassword"
            @input="newPasswordChange"
          />
          <img
            v-if="showNewPassword"
            src="@/assets/img/closeEye.png"
            @click="showNewPassword = !showNewPassword"
          />
          <img
            v-else
            src="@/assets/img/openEye.png"
            @click="showNewPassword = !showNewPassword"
          />
          <span class="showNewPasswordMessage" v-if="showNewPasswordMessage"
            >密码中必须包含大小写字母、数字、特殊字符,长度在8到20位之间。</span
          >
        </div>
        <div class="formInput" v-if="active == 0">
          <p>验证码：</p>
          <input
            placeholder="请输入验证码"
            placeholder-class="placeholder"
            type="text"
            v-model="form.code"
          />
          <div class="btn" v-show="isSend" @click="sendCode">获取验证码</div>
          <div class="btn1" v-show="!isSend">重新获取({{ sec }})</div>
        </div>

        <div class="tip" v-if="active == 3">修改成功！</div>
      </div>

      <div class="button" @click="next">
        {{ active < 2 ? "下一步" : "关闭" }}
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getNewslist, publicityList } from '@/api/mian'
import { cityDetail } from '../../../util/mainOption'
import { checkToken, getPhoneCode, getUserInfoByUserId, login, phoneUpdatePassword } from '../../../api/login'
export default {
  data () {
    return {
      xwdtList: [],
      lunbo: [],
      jyxxList: [],
      zcfgList: [],
      zlxzList: [],
      gsggList: [],
      deptId: "",
      phone: "",
      username: "",
      password: "",
      showPassword: false,
      isShow: false,
      active: 0, //步骤
      form: {
        phone: '',
        code: '',
        newPassword: '',
      },
      showNewPassword: false,
      showNewPasswordMessage: false,
      isSend: true,
      sec: 60,
      isLogin: false,
      userInfoData: {},
      cover: require('@/assets/img/user.png'),
      deptName: "",
    }
  },
  async created () {
    let phone = localStorage.getItem('phone')
    if (phone) {
      let head = phone.slice(0, 3)
      let foot = phone.slice(7, 11)
      this.phone = head + '****' + foot
    }
    this.deptName = this.$route.query.deptName
      ? this.$route.query.deptName
      : this.cityDetail.cityName
    this.checkLoginStatus()
    this.deptId = sessionStorage.getItem("deptId") ? sessionStorage.getItem("deptId") : cityDetail.deptId
    let data = {
      number: '001017',
      pageSize: 10,
      pageNum: 1,
      deptId: this.deptId,
    }
    getNewslist(data).then((res) => {
      this.xwdtList = res.data.rows
    })
    data = {
      number: '010',
      pageSize: 4,
      pageNum: 1,
      deptId: this.deptId,
    }
    getNewslist(data).then((res) => {
      this.lunbo = res.data.rows
    })
    data = {
      number: '002001',
      pageSize: 4,
      pageNum: 1,
      deptId: cityDetail.deptId,
    }
    await getNewslist(data).then((res) => {
      this.zcfgList = res.data.rows
    })
    data = {
      number: '007001',
      pageSize: 4,
      pageNum: 1,
      deptId: cityDetail.deptId,
    }
    await getNewslist(data).then((res) => {
      this.zlxzList = res.data.rows
      console.log('zlxz', this.zlxzList)
    })
    data = {
      number: '030001',
      pageSize: 4,
      pageNum: 1,
      deptId: cityDetail.deptId,
    }
    await getNewslist(data).then((res) => {
      this.gsggList = res.data.rows
      console.log('gsgg', this.gsggList)
    })


    // data = {
    //   number: '004',
    //   pageNum: 1,
    //   pageSize: 10,
    // }
    // publicityList(data).then((res) => {
    // this.jyxxList = res.data.rows
    // })
  },
  mounted () {
  },
  computed: {},
  watch: {},
  methods: {
    checkLoginStatus () {
      checkToken().then(res => {
        if (res.data.code == 200) {
          this.$store.state.isLogin = true
          this.isLogin = true
          getUserInfoByUserId().then(res => {
            console.log("用户个人信息", res)
            this.userInfoData = res.data.data
          })
        } else {
          this.$store.state.isLogin = false
          this.isLogin = false
        }
      })
    },
    // 发送验证码倒计时
    timeJian () {
      if (this.sec == 0) {
        this.isSend = true
        this.sec = 60
        return false
      } else {
        this.isSend = false
        this.sec--
      }
      setTimeout(() => {
        this.timeJian()
      }, 1000)
    },
    // 发送电话号验证码
    sendCode () {
      let testEmail = /^((13[0-9])|(17[0-1,6-8])|(15[^4,\\D])|(18[0-9]))\d{8}$/

      // console.log(this.form.phone)
      if (!this.form.phone) {
        this.$message.warning('请输入电话号码')
        return
      } else if (this.form.phone && !testEmail.test(this.form.phone)) {
        this.$message.warning('请输入正确的电话号码')
        return
      } else {
        this.timeJian()
        getPhoneCode(this.form.phone)
          .then((res) => {
            this.$message.success(res.data.msg)
            this.form.uuid = res.data.uuid
          })
          .catch((err) => {
            this.isSend = false
          })
      }
    },
    newPasswordChange () {
      let regex = new RegExp(
        '(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,20}'
      )
      if (!regex.test(this.form.newPassword)) {
        this.showNewPasswordMessage = true
      } else {
        this.showNewPasswordMessage = false
      }
    },
    login () {
      if (this.username.trim() == '') {
        this.$message.error('手机号不可为空')
      }
      // else if (this.code.trim() == '') {
      //   this.$message.error('验证码不可为空')
      // } 
      else if (this.password.trim() == '') {
        this.$message.error('密码不可为空')
      }
      else {
        login({
          username: this.username,
          password: this.password,
          areaId: this.cityDetail.lesseeId,
          loginType: 0,
        }).then((res) => {
          console.log(res)
          if (res.data.code == 200) {
            this.$message.success('登录成功')
            localStorage.setItem('token', res.data.token)
            localStorage.setItem('phone', this.username)
            this.$cookie.set('status', 'login')
            this.$cookie.set('phone', this.username)
            this.checkLoginStatus()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    next () {
      console.log(this.active)
      let testEmail = /^((13[0-9])|(17[0-1,6-8])|(15[^4,\\D])|(18[0-9]))\d{8}$/
      let regex = new RegExp(
        '(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,20}'
      )
      if (this.active == 0) {
        if (!this.form.phone) {
          this.$message.warning('请输电话号码')
          return
        } else if (this.form.phone && !testEmail.test(this.form.phone)) {
          this.$message.warning('请输入正确的电话号码')
          return
        } else if (!this.form.code) {
          this.$message.warning('请输入验证码')
          return
        } else if (!regex.test(this.form.newPassword)) {
          return
        } else {
          // checkEmailCode(this.form).then(res => {
          //     console.log(res.data);
          //     this.$message.success(res.data.msg)

          // })
          phoneUpdatePassword(this.form).then((res) => {
            this.$message.success(res.data.msg)
            this.active += 3
          })
        }
      } else if (this.active == 1) {
        if (!this.form.phone) {
          this.$message.warning('请输入电话号码')
          return
        } else if (this.form.phone && !testEmail.test(this.form.phone)) {
          this.$message.warning('请输入正确的电话号码')
          return
        } else if (!this.form.newPassword) {
          this.$message.warning('请输入新密码')
          return
        } else {
          // emailUpdatePassword(this.form).then(res => {
          //     this.active++
          //     this.active++
          //     this.$message.success(res.data.msg)
          // })
        }
      } else {
        this.form.phone = ''
        this.form.code = ''
        this.form.newPassword = ''
        this.active = 0
        this.isShow = false
      }
    },

    // 跳转到新闻中心
    toxinwen (num, i) {
      this.$router.push({ name: '新闻中心', query: { number: num, idx: i } })
    },
    // 跳转到通知成交鉴定公告页面
    toGonggao (i) {
      this.$router.push({ path: '/announcement', query: { id: i } })
    },

    // 跳转到通知成交鉴定公告页面
    toChengJiao () {
      this.$router.push({ path: '/chengjiaogonggao' })
    },
  },
}
</script>

<style scoped lang="scss">
ul {
  margin: 0;
  padding: 0;
}

.news {
  display: grid;
  grid-template-columns: 2fr 3fr;
  grid-column-gap: 20px;
  width: 100%;
  /* height: 520px; */
  /* padding-top: 500px; */
  background-color: #ffffff;
  border-bottom: #2187ff 1px solid;
  /* box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.1); */
}
*,
body,
html {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
input {
  border: none;
  outline: none;
}

.lunbo_img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.lunbo_title {
  display: block;
  margin: 0;
  box-sizing: border-box;
  padding: 0 130px 0 50px;
  position: absolute;
  bottom: 0;
  width: 750px;
  height: 60px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  line-height: 60px;
  background: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-carousel /deep/ .el-carousel__container {
  height: 498px !important;
}

/* ul定位 */
.el-carousel /deep/ .el-carousel__indicators--horizontal {
  left: 600px;
  transform: none;
}

.el-carousel /deep/ .el-carousel__indicators--horizontal .el-carousel__button {
  width: 12.4px;
  height: 12.4px;
  border-radius: 50%;
}
.xinwenList {
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
}
.xinwenList > div {
  display: flex;
  flex-direction: column;
}
.xinwenList > div > .title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xinwenList > div > .line_ddd {
  width: 100%;
  height: 4px;
  background-color: #ddd;
}
.xinwenList > div > .line_ddd > .line_blue {
  width: 170px;
  height: 4px;
  background-color: #2187ff;
}
.xinwenList > div > .title > a {
  display: flex;
  align-items: center;
  color: #667fea;
  cursor: pointer;
}
.xinwenList > div > .title > a > img {
  width: 10px;
  height: 10px;
}
.xinwenList > div > .title > span {
  width: 170px;
  text-align: center;
  line-height: 50px;
  height: 50px;
  font-size: 24px;
  color: #2187ff;
  font-weight: bold;
}
.xinwenList > div > .dataList {
  display: flex;
  flex-direction: column;
}
.xinwenList > div > .dataList > div {
  padding: 10px 0;
}
.xinwenList > div > .dataList > div > a {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xinwenList > div > .dataList > div > a > div {
  display: flex;
  align-items: center;
}
.xinwenList > div > .dataList > div > a > div > span {
  font-size: 18px;
  width: 380px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.right > div {
  flex: 1;
}

.loginWin {
  position: absolute;
  left: calc(100% + 10px);
  top: 0;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  width: 250px;
  height: auto;
  .userInfo {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    .userImg {
      i {
        font-size: 40px;
      }
    }
    .loginView {
      .title {
      }
      .area {
      }
    }
  }
  .toLogin {
  }
}
//登录窗口样式
.homeLoginDiv {
  display: flex;
  flex-flow: column wrap;
  width: 100%;
  height: auto;
  .loginStatus {
    display: flex;
    flex-flow: column wrap;
    width: 100%;
    height: 100%;
    align-items: center;
    padding: 40px 0;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    justify-content: center;
    .userHeadImg {
      width: 150px;
      height: auto;
      border: 1px solid #ddd;
      border-radius: 200px;
      overflow: hidden;
      img {
        width: 100%;
        height: auto;
      }
    }
    span {
      font-size: 24px;
      margin-top: 30px;
    }
  }
  .rightLogin {
    display: flex;
    flex-direction: column;
    width: 460px;
    zoom: 1.2;
    .titleDiv {
      text-align: center;
      width: 100%;
      height: 74px;
      background-color: #2187ff;
      .title {
        font-size: 30px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
        line-height: 74px;
      }
    }
    .loginWindow {
      background: url("../../../assets/img/loginfog.png") no-repeat;
      width: 100%;
      background-size: 100% 100%;
      padding: 44px 40px;
      .usernameDiv {
        background-color: #ffffff;
        padding: 16px 20px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        border: 1px solid #c0c4cc;
        margin-bottom: 30px;
        img {
          width: 24px;
          height: 24px;
          margin-right: 16px;
        }
        input {
          flex: 1;
          font-size: 20px;
          width: 100%;
        }
      }
      .passwordDiv {
        background-color: #ffffff;
        padding: 16px 20px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        border: 1px solid #c0c4cc;
        margin-bottom: 20px;
        .passwordImg {
          width: 24px;
          height: 24px;
          margin-right: 16px;
        }
        .passwordInp {
          flex: 1;
          font-size: 20px;
          width: 100%;
        }
        .selectImg {
          width: 20px;
          cursor: pointer;
          margin-left: 6px;
        }
      }
      .loginBtn {
        width: 100%;
        height: 60px;
        justify-content: center;
        display: flex;
        cursor: pointer;
        background-color: #2187ff;
        .loginSpan {
          font-size: 24px;
          font-family: Source Han Sans CN-Medium, Source Han Sans CN;
          font-weight: 500;
          color: #ffffff;
          line-height: 60px;
          margin-bottom: 56px;
          user-select: none;
        }
      }
      .loginFooter {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .registerSpan {
          font-size: 16px;
          font-family: Source Han Sans CN-Medium, Source Han Sans CN;
          font-weight: 500;
          color: #2187ff;
        }
        .forgetPassword {
          font-size: 16px;
          font-family: Source Han Sans CN-Medium, Source Han Sans CN;
          font-weight: 500;
          color: #2187ff;
          cursor: pointer;
        }
      }
    }
  }
}
.passwordDialog >>> .el-dialog__header {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}
.passwordDialog {
  .steps {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 70px;
    display: flex;
    justify-content: center;
  }
  .formView {
    width: 100%;
    box-sizing: border-box;
    padding: 16px 46px 50px 46px;
    margin: 0 auto;
    height: auto;
    /* overflow: hidden; */
    background-color: #ffffff;
  }

  .formInput {
    width: 100%;
    height: 60px;
    border-bottom: 1px solid #e5e5e5;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    position: relative;
    img {
      width: 20px;
      cursor: pointer;
      margin-left: 6px;
    }
    p {
      width: 100px;
      height: 30px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 30px;
      color: #333333;
      text-align: justify;
      text-justify: inter-word;
    }

    input {
      flex: 1;
      height: 40px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 40px;
      color: #333333;
      box-sizing: border-box;
      padding-left: 30px;
    }
    .showNewPasswordMessage {
      position: absolute;
      top: 70%;
      left: 20%;
      font-size: 12px;
      color: #f00;
      user-select: none;
    }
    .placeholder {
      color: #999999;
    }

    .btn {
      width: 170px;
      height: 44px;
      border: 1px solid #369eff;
      opacity: 1;
      border-radius: 50px;
      font-size: 20px;
      font-family: PingFang-SC-Medium;
      line-height: 44px;
      text-align: center;
      color: #369eff;
      cursor: pointer;
    }

    .btn1 {
      width: 170px;
      height: 44px;
      opacity: 1;
      border-radius: 50px;
      font-size: 20px;
      font-family: PingFang-SC-Medium;
      line-height: 44px;
      text-align: center;
      background-color: #757575;
      color: #ffffff;
      cursor: pointer;
    }
  }

  .tip {
    width: 100%;
    height: 100px;
    line-height: 100px;
    font-size: 30px;
    text-align: center;
    color: #369eff;
  }
}
.button {
  width: 90%;
  height: 50px;
  text-align: center;
  font-size: 18px;
  line-height: 50px;
  background-color: #2187ff;
  color: #fff;
  margin: 0 auto;
  border-radius: 50px;
  cursor: pointer;
}
</style>
